export default "__VITE_ASSET__pTqi8lDI__"